import React, { forwardRef } from 'react';
import { twMerge } from 'tailwind-merge';

import Button from 'components/partials/button/button';

import Icons from 'assets/icons';

interface EmptySpaceContentProps {
  image?: React.ReactNode;
  text?: React.ReactNode;
  linkShow?: boolean | null;
  linkText?: string | null;
  onClick?: () => void;
  disabled?: boolean;
  customClass?: string;
  textClass?: string;
  rotation?: 'vertical' | 'horizontal';
}

const DEFAULT_IMAGE = (
  <Icons.EmptyImage className="size-20" aria-hidden="true" />
);

const EmptySpaceContent = forwardRef<HTMLDivElement, EmptySpaceContentProps>(
  (
    {
      image = DEFAULT_IMAGE,
      text,
      linkShow = null,
      linkText = null,
      onClick,
      disabled = false,
      customClass = '',
      textClass = '',
      rotation = 'vertical',
    },
    _ref
  ) => (
    <div
      className={twMerge(
        'flex justify-center items-center text-center rounded-[10px] border border-dashed border-gray-300 bg-gray-50 relative min-h-0',
        customClass
      )}
      data-testid="empty-space-content"
    >
      <div
        className={twMerge(
          'flex items-center font-semibold',
          rotation === 'vertical' && 'flex-col',
          rotation === 'horizontal' && 'flex-row gap-6'
        )}
      >
        <div
          className="animate-bounce-in grayscale"
          data-testid="empty-space-content-image"
        >
          {image}
        </div>

        <span
          className={twMerge(
            'text-base text-gray-700 animate-fade-in',
            textClass
          )}
          data-testid="empty-space-content-text"
        >
          {text}
        </span>

        {linkShow && (
          <Button
            variant="neutral-outlined"
            size="sm"
            iconBefore={<Icons.Plus aria-hidden="true" />}
            className={twMerge(
              rotation === 'vertical' && 'mt-3',
              rotation === 'horizontal' && 'ml-4',
              'border-neutral-300'
            )}
            onClick={onClick}
            disabled={disabled}
            data-testid="empty-space-content-link"
          >
            {linkText}
          </Button>
        )}
      </div>
    </div>
  )
);

export default EmptySpaceContent;
